module.exports = geniussports.GeniusSportsLogger;